import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import axios, { all } from "axios";
import { getFunctions, httpsCallable } from "firebase/functions";

const querySnapshot = collection(db, "routePartnerMainAddress");
export const getWareHouses = (conditions) => {
  const whereConditions = Object.keys(conditions).map((key) =>
    where(key, "==", conditions[key]),
  );
  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, async (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
      // setFilterOptions(prev=>({...prev,warehouses:arr}));
    });
  });
};

export const getWareHouseById = async (id) => {
  const docRef = doc(db, "routePartnerMainAddress", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
};

export const getRoutePartners = (conditions) => {
  const querySnapshot = collection(db, "routePartners");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    condition.push(where(cd.key, `${cd.operator}`, cd.value));
  });
  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getUserDetailsById = async (userId) => {
  if (!userId) return null;
  const userDocSnap = await getDoc(doc(db, "users", userId));
  if (userDocSnap.exists()) {
    console.log(userDocSnap.data(), "userDocSnap.data()");
    return { ...userDocSnap.data(), id: userDocSnap.id };
  }
  return null;
};

export const getOnlySuites = async (conditions) => {
  console.log(conditions, "conditionssss");
  const querySnapshot = collection(db, "mySuites");
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  const q = query(querySnapshot, ...whereConditions);
  try {
    const snapshot = await getDocs(q);
    const arr = [];
    snapshot.forEach((doc) => {
      arr.push({ ...doc.data(), id: doc.id });
    });
    console.log(arr, "final data");
    return arr;
  } catch (error) {
    console.error("Error fetching suites:", error);
    throw error;
  }
};

export const getAllSuites = (conditions) => {
  const querySnapshot = collection(db, "mySuites");
  const condition = [];
  console.log(conditions, "Conditions");

  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, async (snapshot) => {
      const arr = [];

      for (const docSnapshot of snapshot.docs) {
        const mapUserData = docSnapshot.data();
        if (mapUserData.userId) {
          const user = await getUserDetailsById(mapUserData.userId);
          if (user) {
            arr.push({ ...mapUserData, ...user, id: docSnapshot.id });
          } else {
            arr.push({ ...mapUserData, id: docSnapshot.id });
          }
        }
      }
      resolve(arr);
    });
  });
};

export const getShelfPackages = async (conditions) => {
  const querySnapshot = collection(db, "shelfPackages");
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  const snapshot = await getDocs(q);
  const arr = [];
  snapshot.forEach((doc) => {
    console.log({ ...doc.data(), id: doc.id }, "edwfsadfasdf");
    arr.push({ ...doc.data(), id: doc.id });
  });
  console.log(arr, "aasdasdf");
  return arr;
};

export const getShelfConsolidatedPackages = (conditions) => {
  const querySnapshot = collection(db, "shelfConsolidatedPackages");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getDetailsById = (conditions, collectionName) => {
  const querySnapshot = collection(db, collectionName);
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getShelfShoppingPackages = (conditions) => {
  const querySnapshot = collection(db, "shelfShoppingPackages");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        console.log({ ...doc.data(), id: doc.id }, "edwfsadfasdf");
        arr.push({ ...doc.data(), id: doc.id });
      });
      console.log(arr, "aasdasdf");
      resolve(arr);
    });
  });
};

export const getBrands = (conditions = []) => {
  const querySnapshot = collection(db, "brands");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getAllItems = async (itemIds) => {
  // console.log(itemIds,"itemIdsitemIds")
  const items = itemIds.map(async (id) => {
    const docRef = doc(db, "items", id);
    const itemDoc = await getDoc(docRef);
    if (itemDoc.exists()) {
      return itemDoc.data();
    }
  });
  console.log(items, "itemsitems");

  return await Promise.all(items);
};

export const getMySuiteDetails = async (suitId) => {
  const docRef = doc(db, "mySuites", suitId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  }
  return null;
};

export const getCustomersByRoutePartnerId = async (routePartnerId) => {
  console.log(routePartnerId, "routePartnerIddsd");
  const q = query(
    collection(db, "mySuites"),
    where("routePartnerId", "==", `${routePartnerId}`),
  );
  // const querySnapshot = await getDocs(q);
  const arr = [];
  return new Promise((resolve, reject) => {
    onSnapshot(q, async (snapshot) => {
      const arr = new Set();
      const userids = [];
      for (const docSnapshot of snapshot.docs) {
        const mapUserData = docSnapshot.data();
        if (mapUserData.userId && !userids.includes(mapUserData.userId)) {
          userids.push(mapUserData.userId);
          const user = await getUserDetailsById(mapUserData.userId);
          if (user) {
            arr.add({
              email: user?.emailId,
              name: user?.name,
              country: user?.country,
              fcmToken: user?.fcmToken,
              phoneNumber: user?.phoneNumber,
              id: mapUserData.userId,
            });
          }
        }
      }
      resolve([...arr]);
    });
  });
  // querySnapshot.forEach(async(doc) => {
  //   const data = doc.data();
  //   const userdetails = await getUserDetailsById(data.userId);
  //   console.log(userdetails,"sdsdfassaasd")
  //   arr.push(userdetails?.emailId);
  // });
  // return arr;
};

export const getAllUsers = async () => {
  const q = query(collection(db, "users"));
  const querySnapshot = await getDocs(q);
  const arr = new Set();
  querySnapshot.forEach((doc) => {
    if (doc.data()?.emailId) {
      arr.add({
        email: doc.data()?.emailId,
        name: doc.data()?.name,
        country: doc.data()?.country,
        fcmToken: doc.data()?.fcmToken,
        id: doc.id,
        phoneNumber: doc.data()?.phoneNumber,
      });
    }
  });
  return [...arr];
};

export const updateMySuiteDetails = async (suitId, data) => {
  const docRef = doc(db, "mySuites", suitId);
  return await updateDoc(docRef, data);
};

export const getUserCounts = async (userId) => {
  const q1 = query(collection(db, "mySuites"), where("userId", "==", userId));
  const querySnapshot1 = await getDocs(q1);
  return querySnapshot1.size;
};

export const updateShelfPackageDetails = async (packageId, data) => {
  console.log(packageId, data, "packageId, data");

  const docRef = doc(db, "shelfPackages", packageId);
  return await updateDoc(docRef, data);
};

export const updateShelfShoppingPackageDetails = async (packageId, data) => {
  console.log(packageId, data, "details about package");
  const adminRef = doc(db, "shelfShoppingPackages", packageId);
  await updateDoc(adminRef, data);
};

export const updateItemDetails = async (itemId, data) => {
  console.log(itemId, data, "all derfsdfsdf");

  const docRef = doc(db, "items", itemId);
  return await updateDoc(docRef, data);
};

export const addNewShelfPackage = async (data) => {
  const packageSettings = await getDoc(doc(db, "masterData", "packageSetting"));

  if (packageSettings.exists()) {
    const docData = packageSettings.data();
    console.log(docData, data, "docData");

    const docRef = doc(
      db,
      "shelfPackages",
      `PACK-${docData.currentId.toString()}`,
    );
    console.log(docRef, "docRef");
    await setDoc(docRef, {
      ...data,
      id: docRef.id,
      packageTrackingId: docRef.id,
    });
    console.log("dsdssadadsaddsdadf");
    await updateDoc(doc(db, "masterData", "packageSetting"), {
      currentId: docData.currentId + docData.incrementBy,
    });
    return {
      ...data,
      id: docRef.id,
      packageTrackingId: docRef.id,
    };
  } else {
    return null;
  }
};

export const getMasterData = async () => {
  const masterDataRef = doc(db, "masterData", "packageSetting");
  const masterData = await getDoc(masterDataRef);
  return masterData.data();
};

export const updateMasterData = async (data) => {
  const masterDataRef = doc(db, "masterData", "packageSetting");
  return await updateDoc(masterDataRef, data);
};

export const getLatestShelfPackage = async (mySuiteId) => {
  const latestPackageQuery = query(
    collection(db, "shelfPackages"),
    where("arrivedAt", "!=", null),
    where("mySuiteId", "==", mySuiteId),
    orderBy("arrivedAt", "desc"),
    limit(1),
  );
  const latestPackageSnapshot = await getDocs(latestPackageQuery);
  return latestPackageSnapshot.empty
    ? null
    : latestPackageSnapshot.docs[0].data();
};

export const getAddons = async (conditions) => {
  const querySnapshot = collection(db, "mySuiteAddOns");
  console.log(conditions, "conditionsconditions");

  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getItem = async (itemId) => {
  const docRef = doc(db, "items", itemId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
  return null;
};

export const getFormDetails = async (itemId) => {
  console.log(itemId, "itemId in getFormDetails");

  const docRef = doc(db, "forms", itemId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
  return null;
};

export const getPostpalMarkups = async () => {
  const markups = await axios.get(
    `https://getcouriers-c3ryyxocoa-uc.a.run.app?routePartnerId=611153`,
    {
      headers: {
        "x-api-key": "AIzaSyBEUzPpNkv0brQkBgEL8zEuHMUKk1AMjZE",
      },
    },
  );
  console.log(markups, "dsdadfadsdaf");
  return markups?.data?.couriers;
};

export const getWarehousesCloud = async () => {
  const warehouses = await axios.get(
    "https://getroutepartnermainaddresses-c3ryyxocoa-uc.a.run.app",
    {
      headers: {
        "x-api-key": "AIzaSyBEUzPpNkv0brQkBgEL8zEuHMUKk1AMjZE",
      },
    },
  );
  console.log(warehouses, "dsdadfadf");
  return warehouses?.data?.addresses;
};

// export const updateItemsDetails = async (payload) => {
//   const updatedItem = await axios.post("https://updateshoppingitemprice-kh7okbs2hq-uc.a.run.app", payload);

//   return updatedItem;
// }
export const updateItemsDetails = async (payload) => {
  // Directly update with the provided payload (no validation/mapping)
  const itemRef = doc(db, "items", payload?.itemId);
  await updateDoc(itemRef, payload);
  return true;
};
export const sendNotification = async (
  userId,
  title,
  body,
  details,
  actionText,
) => {
  const user = await getUserDetailsById(userId);
  console.log(user, "sjjdfjdnf");
  const notificationPayload = {
    body: body,
    desc: "",
    identifier: details?.number || "",
    isRead: false,
    sentOn: serverTimestamp(),
    title: title,
    type: details?.type || "",
    userId: userId,
    actionText: actionText || "",
  };
  console.log(notificationPayload, "notificationPayload");

  const notification = await addDoc(
    collection(db, "notifications"),
    notificationPayload,
  );
  if (user?.fcmToken) {
    const payload = {
      token: user?.fcmToken,
      title: title,
      body: body,
      data: {
        identifier: details?.number,
        type: details?.type,
      },
    };
    // Use Firebase callable function instead of REST API
    const functions = getFunctions();
    const sendPushNotification = httpsCallable(
      functions,
      "sendPushNotification",
    );
    try {
      const result = await sendPushNotification(payload);
      console.log("sendPushNotification result:", result.data);
    } catch (error) {
      console.error("sendPushNotification error:", error);
    }
  }
};

export const sendMail = async (data) => {
  const functions = getFunctions();
  const callableReturnMessage = httpsCallable(functions, "sendEmail");
  return await callableReturnMessage({
    email: data.email,
    subject: data.subject,
    content: data.content,
  });
};

export const generateReceiveMail = (data) => {
  const mess = `Hello ${data?.name}
We are excited to inform you that your package with UPS tracking number: ${data?.trackingNumber} has arrived at our warehouse and has been assigned the Package ID: ${data?.packageId} .
_________________________________________________________________________________________________________________

 Important Note:
Your package is now available on your shelf under "packages".
__________________________________________________________________________________________________________________

Next Steps: Request "Prepare Shipment" 
     1.Open the app and navigate to "My Suite" from the homepage.
     2.Go to your "Shelf" and locate Package ID: {Pack_ID} .
     3.Click to open the package details.

You'll be able to request for your package to be "Prepared for Shipment".
___________________________________________________________________________________________________________________

Additional Services You Might Love:

      Item Add-ons
      Request extra services like:
          More photos
          Condition check
          Check Measurements
          …and more!
      Package Add-ons
      Personalize your shipment with options like:
          Record My Shipment
          Remove Price Tag
          …and so much more!
___________________________________________________________________________________________________________________

We look forward to getting your package ready and on its way! 
Happy Shipping with POSTPAL!
___________________________________________________________________________________________________________________

Thank you for choosing POSTPAL,

Your team @POSTPAL `;

  const mess1 = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Package Arrival Notification</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      color: #333;
      line-height: 1.6;
    }
    .container {
      max-width: 600px;
      margin: auto;
      padding: 20px;
      border: 1px solid #eaeaea;
      border-radius: 8px;
      background-color: #f9f9f9;
    }
    h2 {
      color: #2c3e50;
    }
    .note, .services {
      margin-top: 20px;
    }
    ul {
      padding-left: 20px;
    }
    .footer {
      margin-top: 30px;
      font-size: 0.9em;
      color: #888;
    }
  </style>
</head>
<body>
  <div class="container">
    <h2>Hello ${data?.name},</h2>

    <p>We are excited to inform you that your package with ${data?.logisticPartner || ""} tracking number: <strong>${data?.trackingNumber}</strong> has arrived at our warehouse and has been assigned the Package ID: <strong>${data?.packageId}</strong>.</p>

    <div class="note">
      <h4>Important Note:</h4>
      <p>Your package is now available on your shelf under <strong>"packages"</strong>.</p>
    </div>

    <div class="next-steps">
      <h4>Next Steps: Request "Prepare Shipment"</h4>
      <ol>
        <li>Open the app and navigate to "My Suite" from the homepage.</li>
        <li>Go to your "Shelf" and locate Package ID: <strong>${data?.packageId}</strong>.</li>
        <li>Click to open the package details.</li>
        <li>You'll be able to request for your package to be "Prepared for Shipment".</li>
      </ol>
    </div>

    <div class="services">
      <h4>Additional Services You Might Love:</h4>
      <p><strong>Item Add-ons</strong><br>
      Request extra services like:</p>
      <ul>
        <li>More photos</li>
        <li>Condition check</li>
        <li>Check Measurements</li>
      </ul>

      <p><strong>Package Add-ons</strong><br>
      Personalize your shipment with options like:</p>
      <ul>
        <li>Record My Shipment</li>
        <li>Remove Price Tag</li>
        <li>…and so much more!</li>
      </ul>
    </div>

    <div class="footer">
      <p>We look forward to getting your package ready and on its way!<br>
      Happy Shipping with POSTPAL!</p>

      <p>Thank you for choosing POSTPAL,<br>
      Your team @POSTPAL</p>
    </div>
  </div>
</body>
</html>
`;

  return mess1;
};

export const generateReceiveMailForNotHaveItems = (data) => {
  const mess = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Action Required: Add Items to Your Package</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      color: #333;
      line-height: 1.6;
    }
    .container {
      max-width: 600px;
      margin: auto;
      padding: 20px;
      border: 1px solid #eaeaea;
      border-radius: 8px;
      background-color: #f9f9f9;
    }
    h2 {
      color: #2c3e50;
    }
    .section {
      margin-top: 20px;
    }
    ul, ol {
      padding-left: 20px;
    }
    .footer {
      margin-top: 30px;
      font-size: 0.9em;
      color: #888;
    }
  </style>
</head>
<body>
  <div class="container">
    <h2>Hello ${data?.name},</h2>

    <p>We are excited to inform you that your package with tracking number: <strong>${data?.trackingNumber}</strong> has arrived at our warehouse and has been assigned the Package ID: <strong>${data?.packageId}</strong>.</p>

    <div class="section">
      <h4>Important Note:</h4>
      <p>Your package does not have any items listed.</p>
    </div>

    <div class="section">
      <h4>Action Required:</h4>
      <p><strong>You MUST enter the item(s)</strong> of your package before requesting us to prepare it for shipment.</p>
      <p><em>Why?</em><br>This information is essential to complete your customs declaration forms.</p>
    </div>

    <div class="section">
      <h4>Next Steps: Request "Prepare Shipment"</h4>
      <ol>
        <li>Open the app and navigate to "My Suite" from the homepage.</li>
        <li>Go to your "Shelf" and locate Package ID: <strong>${data?.packageId}</strong>.</li>
        <li>Click to open the package details.</li>
        <li>Tap the "+" icon at the bottom of your screen to add items:
          <ul>
            <li>Manually Add Items</li>
            <li>Add Items from Store</li>
          </ul>
        </li>
        <li>Once you've added your items, you'll be able to request for your package to be "Prepared for Shipment".</li>
      </ol>
    </div>

    <div class="section">
      <h4>Additional Services You Might Love:</h4>
      <p><strong>Item Add-ons</strong><br>Request extra services like:</p>
      <ul>
        <li>More photos</li>
        <li>Condition check</li>
        <li>Check Measurements</li>
      </ul>

      <p><strong>Package Add-ons</strong><br>Personalize your shipment with options like:</p>
      <ul>
        <li>Record My Shipment</li>
        <li>Remove Price Tag</li>
        <li>…and so much more!</li>
      </ul>
    </div>

    <div class="footer">
      <p>We look forward to getting your package ready and on its way!<br>
      Happy Shipping with POSTPAL!</p>

      <p>Thank you for choosing POSTPAL,<br>
      Your team @POSTPAL</p>
    </div>
  </div>
</body>
</html>
`;

  return mess;
};

const fetchingData = async (page) => {
  const options = {
    method: "GET",
    headers: {
      accept: "application/json",
      authorization: `Bearer prod_jF/0wVh8rumMKWUjqm1ZY4RyX/xsFkJedn8dj61UhtY=`,
    },
  };
  const response = await fetch(
    `https://public-api.easyship.com/2024-09/couriers?page=${page}&per_page=100`,
    options,
  );
  const response_1 = await response.json();
  return response_1;
};

export const getAllCouriersFromEasyShip = async () => {
  const allCouries = [];
  let page = 1;
  let response = null;
  while (response === null || response?.meta?.pagination?.next) {
    console.log(page, "pahhhhhhh");
    response = await fetchingData(page);
    console.log(response, "pahhhhhhh");
    allCouries.push(...response.couriers);
    page++;
  }
  console.log(allCouries, "allCouriesdasdfsdf");
  return allCouries;
};

/**
 * Adds a new item to the 'items' collection in Firestore.
 * @param {Object} data - The item data to add. Should include image URLs and other fields.
 * @param {Object} packageData - The package data to get userId from.
 * @returns {Promise<string>} - The new document ID.
 */
export const addNewItem = async (data, packageData, isShoppingItem) => {
  try {
    // Parse dimensions from the dimensions string
    const parseDimensions = (dimensionsStr) => {
      if (!dimensionsStr) return { L: 0, W: 0, H: 0 };

      // Parse format like "1.2 x 1.2 x 4.0" or "L x W x H"
      const parts = dimensionsStr.split("*").map((part) => part.trim());
      if (parts.length === 3) {
        return {
          L: parseFloat(parts[0]) || 0,
          W: parseFloat(parts[1]) || 0,
          H: parseFloat(parts[2]) || 0,
        };
      }
      return { L: 0, W: 0, H: 0 };
    };

    const parsedDimensions = parseDimensions(data.dimensions);

    // Transform the data to match the expected Firestore schema
    const itemData = {
      // Basic item information
      name: data.itemName,
      shortenedName:
        data.itemName.length > 50
          ? data.itemName.substring(0, 50) + "..."
          : data.itemName,
      link: data.itemLink,
      itemImageURL:
        data.itemImages && data.itemImages.length > 0 ? data.itemImages[0] : "",
      itemImages: data.itemImages || [],
      additionalImages: [], // Additional images array

      // Pricing and quantity
      price: parseFloat(data.valuePerItem) || 0,
      declaredItemPrice: parseFloat(data.valuePerItem) || 0,
      quantity: parseInt(data.quantity) || 1,

      // Physical properties
      weight: parseFloat(data.weightPerItem) || 0,
      dimensions: data.dimensions || "",
      dimensionL: parsedDimensions.L,
      dimensionW: parsedDimensions.W,
      dimensionH: parsedDimensions.H,

      // Item details
      itemCondition: data.itemCondition || "New",
      itemType: isShoppingItem ? "SHOPPING" : "SHIPPING",
      itemAddedFrom: "MANUAL",
      itemEditedFrom: "MANUAL",

      // Purchase status
      hasReceipt: data.purchasedBefore === "yes_receipt",
      notPurchased: data.purchasedBefore === "no",
      receiptDocUrls: data.receiptDocUrls || [],

      // Status fields
      preShoppingStatus: "",
      postShoppingStatus: "",
      preShippingStatus: "",
      postShippingStatus: "",
      trackingNumber: "",

      // Additional fields
      needShoppingAssistance: data.needAssistance === "yes",
      promoCode: "",
      hscode: "",
      merchantShippingCost: 0,

      // Brand and category information
      brandImage: "",
      brandName: "",
      category: "",
      subcategory: "",

      // Addons and restrictions
      addonsList: [],
      customIqSuggestions: [],
      customiqRestrictions: {
        additionalBattery: { customIqResponse: false, humanValidation: false },
        alcohol: { customIqResponse: false, humanValidation: false },
        animalOrAnimalExtract: {
          customIqResponse: false,
          humanValidation: false,
        },
        bullionOfAnyKind: { customIqResponse: false, humanValidation: false },
        cbdOrThc: { customIqResponse: false, humanValidation: false },
        counterfeitOrReplica: {
          customIqResponse: false,
          humanValidation: false,
        },
        dangerousGoods: { customIqResponse: false, humanValidation: false },
        endangeredSpecies: { customIqResponse: false, humanValidation: false },
        engineParts: { customIqResponse: false, humanValidation: false },
        explosives: { customIqResponse: false, humanValidation: false },
        externalBattery: { customIqResponse: false, humanValidation: false },
        flammable: { customIqResponse: false, humanValidation: false },
        frozen: { customIqResponse: false, humanValidation: false },
        gunAndGunAccessories: {
          customIqResponse: false,
          humanValidation: false,
        },
        highFashion: { customIqResponse: false, humanValidation: false },
        hookahOrWaterPipes: { customIqResponse: false, humanValidation: false },
        ifFresh: { customIqResponse: false, humanValidation: false },
        illicitDrug: { customIqResponse: false, humanValidation: false },
        licenseRequired: { customIqResponse: false, humanValidation: false },
        lithiumIonBattery: { customIqResponse: false, humanValidation: false },
        nonMuslimReligiousItem: {
          customIqResponse: false,
          humanValidation: false,
        },
        perfumeAndColognes: { customIqResponse: false, humanValidation: false },
        perishableFood: { customIqResponse: false, humanValidation: false },
        pornography: { customIqResponse: false, humanValidation: false },
        prescriptionRequired: {
          customIqResponse: false,
          humanValidation: false,
        },
        processedFood: { customIqResponse: false, humanValidation: false },
        prohibited: { customIqResponse: false, humanValidation: false },
        religiousItemsOrObjects: {
          customIqResponse: false,
          humanValidation: false,
        },
        restricted: { customIqResponse: false, humanValidation: false },
        seedsOrLivePlants: { customIqResponse: false, humanValidation: false },
        sexToysOrObjects: { customIqResponse: false, humanValidation: false },
        standaloneBatteries: {
          customIqResponse: false,
          humanValidation: false,
        },
        supplements: { customIqResponse: false, humanValidation: false },
        tobaccoProducts: { customIqResponse: false, humanValidation: false },
        vippingDevice: { customIqResponse: false, humanValidation: false },
      },

      // User information - get from package data
      userId: packageData?.userId || "",

      // Timestamps
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    };

    const docRef = await addDoc(collection(db, "items"), itemData);
    return docRef.id;
  } catch (error) {
    console.error("Error adding new item:", error);
    throw error;
  }
};

export const sendNotificationFunction = async ({
  eventType,
  eventStatus,
  fcmToken,
  userId,
  mailId,
  payload,
}) => {
  const functions = getFunctions();
  const callableSendNotification = httpsCallable(
    functions,
    "sendPostPalNotification",
  );
  try {
    const result = await callableSendNotification({
      eventType,
      eventStatus,
      fcmToken,
      userId,
      mailId,
      payload,
    });
    return result.data;
  } catch (error) {
    console.error("Error sending notification:", error);
    throw error;
  }
};

// Mapping function: Firestore -> Redux state shape
export function mapFirestoreToRedux(data, id) {
  return {
    id,
    routePartner: data.routePartner || { id: "", name: "" },
    selectedCountry: data.toCountry || data.selectedCountry || "",
    selectedState: data.toState || data.selectedState || "",
    transitDayRange: data.transitDayRange || "",
    shippingServiceType: data.shippingServiceType || "",
    wareHouseDetails: data.wareHouseDetails || { id: "", warehouseName: "" },
    deliveryPartner: data.deliveryPartner || {
      id: "",
      name: "",
      partnerType: "",
    },
    carrierPartner: data.carrierPartner || { id: "", carrierPartnerName: "" },
    createdAt: data.createdAt || "",
    updatedAt: data.updatedAt || "",
    // --- Add all ShippingPriceStep fields below ---
    shippingPartner: data.shippingPartner || "",
    shippingId: data.shippingId || "",
    rates: data.rates || [
      { minWeight: "", maxWeight: "", pricePerLb: "", buyIn: "" },
    ],
    maxLbPerPackage: data.maxLbPerPackage || "",
    additionalLbPerPackage: data.additionalLbPerPackage || "",
    addCustoms: data.addCustoms || [],
    baseRate: data.baseRate || "",
    riskSurcharge: data.riskSurcharge || "",
    serviceFees: data.serviceFees || { doorToDoorFee: "", pickUpFee: "" },
    tracking: typeof data.tracking === "boolean" ? data.tracking : false,
    maxDimension: data.maxDimension || { L: "", W: "", H: "" },
    minimumWeight: data.minimumWeight || "",
    // --- End ShippingPriceStep fields ---
  };
}
